import React, { useState } from "react";
import Resume from "../assets/Resume.pdf";
import CText from "./CText";

function Example() {
  // const ResumeLink =
  //   "https://drive.google.com/file/d/18CHOk9mwQUyFyk-t5bvR2VeK8rNtY1JI/view?usp=sharing";
  const whiteListedIpAddresses = ["103.244.175.245", "149.71.32.53"];
  const [loading, setloading] = useState(false);
  const ResumeDownloadButton = () => {
    const handleDownload = async () => {
      try {
        setloading(true);
        // window.open(ResumeLink, "_blank");
        const downloadLink = document.createElement("a");
        downloadLink.href = Resume; // Path to your resume file
        downloadLink.download = "Abdullah's Resume (Frontend).pdf"; // Specify the desired filename
        downloadLink.click();

        const ipAddress = await fetch("https://api.ipify.org?format=json")
          .then((response) => response.json())
          .then((data) => {
            // console.log({ data });
            return data.ip;
          });

        if (!whiteListedIpAddresses.includes(ipAddress)) {
          const res = await fetch(
            "https://abdullahibm404-default-rtdb.firebaseio.com/portfolioViewers.json",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ ipAddress, message: "Resume Downloaded" }),
            }
          );
          console.log({ res });
        }
        setloading(false);
      } catch (e) {
        setloading(false);

        console.log(e);
      }
    };

    return (
      <button
        disabled={loading}
        loading={loading}
        className="resumeButton"
        onClick={handleDownload}
      >
        {loading ? "Loading Resume..." : "Download Resume"}
      </button>
    );
  };
  return (
    <div className="navbarSection">
      <div className="d-flex justify-content-between align-content-center">
        <CText className="navbarTitle" fontSize="2.5rem" text="AI." />

        {ResumeDownloadButton()}
      </div>
    </div>
  );
}

export default Example;
